import { useEffect, useRef } from 'react';

function GoogleSignInButton({ onCredential }) {
    const buttonRef = useRef(null);
    const callbackRef = useRef(onCredential);
    callbackRef.current = onCredential;

    useEffect(() => {
        const initGoogle = () => {
            window.google.accounts.id.initialize({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                callback: (response) => callbackRef.current(response),
            });
            window.google.accounts.id.renderButton(buttonRef.current, {
                theme: 'outline',
                size: 'large',
                width: buttonRef.current?.clientWidth || 320,
            });
        };

        if (window.google) {
            initGoogle();
        } else {
            const script = document.querySelector('script[src*="accounts.google.com/gsi/client"]');
            if (script) {
                script.addEventListener('load', initGoogle);
                return () => script.removeEventListener('load', initGoogle);
            }
        }
    }, []);

    return <div ref={buttonRef} style={{ width: '100%' }} />;
}

export default GoogleSignInButton;
